const MappaLinks = () => {
    const select = document.getElementById('regioni-select');
    if (!select) return;
    const button = document.getElementById('regioni-btn');
    
    // Abilita/disabilita il pulsante in base alla selezione
    select.addEventListener('change', function() {
        const selectedValue = this.value;
        button.disabled = !selectedValue;
        
        // Evidenzia la regione sulla mappa
        const regionId = this.options[this.selectedIndex].dataset.region;
        highlightRegion(regionId);
    });
    
    // Gestisce il click del pulsante
    button.addEventListener('click', function() {
        const selectedValue = select.value;
        if (selectedValue) {
            window.open(selectedValue, '_blank');
        }
    });
    
    // Funzione per evidenziare la regione sulla mappa
    function highlightRegion(regionId) {
        // Rimuovi evidenziazione precedente
        document.querySelectorAll('#mappa-italia path').forEach(path => {
            path.classList.remove('region-highlighted');
        });
        
        // Evidenzia la regione selezionata
        if (regionId) {
            const regionPath = document.querySelector('#mappa-italia path[id="' + regionId + '"]');
            if (regionPath) {
                regionPath.classList.add('region-highlighted');
            }
        }
    }
}
export default MappaLinks;